import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeFiesta, TypeMini, TypePrius } from '@at/design-system-foundation'
import { Button, CheckBox, Radio } from '@at/design-system-elements'

export const StyledCheckboxForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;
`

export const StyledSearchFilterSelect = styled(TypeMini)<{ $hasDescription?: boolean }>`
    ${({ $hasDescription = false, theme }) => {
        return css`
            display: flex;
            justify-content: space-between;
            label {
                color: inherit;
                font-size: 14px;
                align-items: center;
            }
            cursor: pointer;
            ${$hasDescription
                ? css`
                      padding: ${ThemeSelectors.getGridUnit(theme)} 0 0 0;
                  `
                : css`
                      padding: ${ThemeSelectors.getGridUnit(theme)} 0;
                  `}
            width: calc(100% - ${ThemeSelectors.getGridUnit(theme)});
            .atds-field__toggle {
                background-color: ${theme.color.bg.default};
            }
        `
    }}
`

export const StyledSearchFilterDescription = styled(TypePrius)`
    padding-bottom: ${({ theme }) => ThemeSelectors.getGridUnit(theme)};
    max-width: 87%;
`

export const StyledSearchFilterSelectContainer = styled.div`
    & > section {
        & label {
            & > span {
                font-variation-settings: normal;
            }
        }
        margin: 0;
        max-width: none;
        width: 10%;
    }
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 4px;
`

export const StyledSearchFilterSelectLabel = styled(TypeFiesta)`
    ${({ theme }) => {
        return css`
            display: flex;
            text-align: start;
            background-color: transparent;
            color: ${theme.color.text.title};
            font-size: 16px;
            align-items: center;
            font-variation-settings: 'wght' 400;
        `
    }}
`

export const StyledSearchFilterSelectLabelCount = styled(TypePrius)`
    ${({ theme }) => {
        return css`
            display: flex;
            align-items: center;
            font-size: 14px;
            color: ${theme.color.text.default};
        `
    }}
`

export const StyledSelectionContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: auto;
`

export const StyledLabelAndIconContainer = styled.div`
    display: flex;
    justify-content: left;
    align-items: center;
    width: auto;
    gap: 16px;
`
export const StyledRadioElement = styled(Radio)<{ $isWrittenOff?: boolean }>`
    width: 24px;

    ${({ $isWrittenOff }) => {
        if ($isWrittenOff) {
            return css`
            label {
                ::before {
                    top: -16px;
                }
                ::after {
                    top: -10px;
                }
            `
        }
    }}
`

export const StyledCheckBoxElement = styled(CheckBox)`
    width: 24px;
    label {
        ::before {
            top: -15px;
        }
        ::after {
            top: -8px;
        }
    }
`

export const StyledColourIcon = styled.div<{ colourGradient: string }>`
    ${({ colourGradient }) => {
        return css`
            width: 24px;
            height: 24px;
            background-image: ${colourGradient};
            background-color: ${colourGradient};
            // transform to have vertical gradient
            transform: rotate(90deg);
            border-radius: 50%;
        `
    }}
`

export const StyledMoreOptionsSVG = styled.svg``

export const ShowMoreOptionsButton = styled(Button)`
    &.more-options-button {
        &:hover {
            background-color: transparent;
        }
        padding-left: 0;
        justify-self: start;
    }
`
